import { Dictionary } from 'src/app/core/model/dictionary';
import { Address } from 'src/app/member/model/member';
import { Department } from './../../core/model/department';
import { OrganizationIdentifier } from '../model/organizationIdentifier';

export class OrganizationEdit
{
    public id = null;
    public name = '';
    public comments = '';
    public parentOrganization: any = null;
    public active = true;
    public departments: Department[] = [];
    public organizationType: Dictionary;
    public address: Address;
    public lastName: string = null;
    public firstName: string = null;
    public email: string = null;
    public homePhoneNumber: string = null;
    public cellPhoneNumber: string = null;
    public faxNumber: string = null;
    public referralChannelId: number = null;
    public consentCollects: Dictionary[] = [];
    public consentViews: Dictionary[] = [];
    public allowTribal = null;
    public submittingOrganization = null;
    public identifiers: OrganizationIdentifier[] = [];
    public extensions: any[] = [];
}
